<template>
  <div class="text-start">
    <youtube
      v-if="widgetName === 'youtube'"
      :youtube-id="widgetData.id"
    />
    <offer-request-button
      v-else-if="widgetName === 'offer_request_button'"
      :place-id="offerRequestPlaceId"
      :custom-button-text="'custom_button_text' in widgetData && widgetData.custom_button_text !== '' ? widgetData.custom_button_text : null"
    />
    <CustomButton
      v-else-if="widgetName === 'custom_button'"
      :title="'text' in widgetData && widgetData.text !== '' ? widgetData.text : null"
      :link="'link' in widgetData && widgetData.link !== '' ? widgetData.link : null"
    />
    <!-- Devre van, hogy lássuk ha valamit elirtunk, mit kapunk a parserbe -->
    <div v-else>
      <div>
        Missing widget: {{ widgetName }}
      </div>
      <div>
        {{ widgetData }}
      </div>
    </div>
  </div>
</template>

<script>
import Youtube from '../widgets/youtube/Youtube.vue'
import OfferRequestButton from '../widgets/buttons/OfferRequestButton.vue'
import CustomButton from '../widgets/buttons/CustomButton.vue'

export default {
  name: 'WidgetParser',
  components: {
    CustomButton,
    OfferRequestButton,
    Youtube,
  },
  props: {
    /**
     * widget neve
     */
    widgetName: {
      type: String,
      required: true,
    },
    /**
     * widget adatai
     */
    widgetData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    offerRequestPlaceId() {
      if (!('place_id' in this.widgetData) || this.widgetData.place_id === '') {
        // opcionális, nem baj, ha nincs.
        return null
      }
      if (this.widgetData.place_id.match(/^[0-9]+$/)) {
        return parseInt(this.widgetData.place_id)
      } else {
        console.error('Érvénytelen formátum a widgetData ban: ' + this.widgetData.place_id)
        return null
      }
    },
  },
}
</script>
